import { render } from "./CustomerCompleteProfileForm.vue?vue&type=template&id=cdea3c02"
import script from "./CustomerCompleteProfileForm.vue?vue&type=script&lang=js"
export * from "./CustomerCompleteProfileForm.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__